import React from 'react';

const HiraganaLoader = () => {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'white',
      zIndex: 9999,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: "'Manrope', sans-serif",
      gap: '32px'
    }}>
      <div style={{
        fontSize: '18px',
        fontWeight: '500',
        color: '#6B7280'
      }}>
        Loading
      </div>
      
      <div style={{
        display: 'flex',
        gap: '12px',
        alignItems: 'center'
      }}>
        {['あ', 'い', 'う', 'え', 'お'].map((char, i) => (
          <div
            key={i}
            style={{
              fontSize: '24px',
              color: '#9333EA',
              fontWeight: '400',
              animation: `fadeInOut 2s ease-in-out infinite`,
              animationDelay: `${i * 0.3}s`,
              opacity: 0
            }}
          >
            {char}
          </div>
        ))}
      </div>
      
      <style>{`
        @keyframes fadeInOut {
          0%, 80%, 100% {
            opacity: 0;
            transform: translateY(0px);
          }
          20%, 60% {
            opacity: 1;
            transform: translateY(-2px);
          }
        }
      `}</style>
    </div>
  );
};

export default HiraganaLoader;